import listReducer from './list/reducer';

export default {
  orderList: listReducer,
};
